import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/Property/PropertyBrowser")
	}

	render() {
		return (
			<Activity 
				name="Property"
				RenderedComponent={this.RenderedComponent}
				context="Property"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyActivity)
